<template>
    <div class="flex border-gray-200 bg-white">
        <div class="flex flex-1">
            <div
                v-if="estimate.cannot_be_edited_by_authed_user"
                class="w-full text-sm -mb-px px-2 py-1.5 border border-gray-200 shadow-none relative"
                v-text="item.name"
            ></div>
            <materials-search-dropdown v-else #default="{ open, opened, query, setQuery }" @selected="updateMaterial" :estimate="estimate" :current="item.name" class="flex w-full" trigger-class="flex w-full">
                <input
                    class="text-sm -mb-px px-2 py-1.5 border border-gray-200 shadow-none relative hover:z-10 focus:z-20"
                    type="text"
                    ref="description"
                    :value="opened ? query : item.name"
                    :title="item.name"
                    @input="setQuery($event.target.value)"
                    @focus="open"
                >
            </materials-search-dropdown>
        </div>
        <div class="w-40 -ml-px">
            <div
                v-if="estimate.cannot_be_edited_by_authed_user"
                class="text-sm -mb-px px-2 py-1.5 border border-gray-200 shadow-none relative"
                :class="hasSupplier ? '' : 'text-gray-500 italic'"
                v-text="supplierName"
            ></div>
            <materials-suppliers-search-dropdown v-else #default="{ open, opened, query, setQuery }" :material-spec="item" @selected="updateSupplier" :estimate="estimate">
                <input
                    class="text-sm -mb-px px-2 py-1.5 border border-gray-200 shadow-none relative hover:z-10 focus:z-20"
                    :class="hasSupplier ? '' : 'text-gray-500 italic'"
                    type="text"
                    ref="description"
                    :value="opened ? query : supplierName"
                    :title="supplierName"
                    @input="setQuery($event.target.value)"
                    @focus="open"
                >
            </materials-suppliers-search-dropdown>
        </div>
        <materials-price-update-dropdown #default="{ inputValue, inputListener }" :material-spec="item" @updated="updatePrice" class="w-32 -mr-px flex" trigger-class="flex w-full">
            <estimates-old-page-cell
                currency
                class="text-sm text-right -ml-px -mb-px px-2 py-1.5 border border-gray-200"
                placeholder="Total"
                :value="inputValue"
                @input="inputListener"
            ></estimates-old-page-cell>
        </materials-price-update-dropdown>
        <div class="w-32 -ml-px -mb-px border border-gray-200 bg-gray-50 px-2 py-1.5 text-sm text-right">
            {{ item.quantity | rounded }}
        </div>
        <div class="w-32 -ml-px -mb-px border border-gray-200 bg-gray-50 px-2 py-1.5 text-sm text-right">
            {{ item.price | toCurrency }}
        </div>
    </div>
</template>

<script>
import {debounce} from 'lodash'
import {estimateStore} from '@stores'

export default {
  props: {
    item: Object,
  },
  computed: {
    $store() {
      return estimateStore
    },
    estimate() {
      return estimateStore.state.estimate
    },
    hasSupplier() {
      return !!this.item.company_id
    },
    supplierName() {
      return this.hasSupplier ? this.item.company_name : 'No Supplier'
    },
  },
  methods: {
    async updateMaterial(material) {
      this.item.material_id = material.id
      this.item.material.id = material.id
      this.item.material.name = material.name
      const newSupplier = material.current_company ?? material.default_company ?? null
      if (newSupplier) {
        this.updateSupplier(newSupplier, {
          material_id: material.id
        })
      } else {
        this.update({
          material_id: material.id,
          company_id: null,
          price: 0,
        })
      }
    },
    async updateSupplier(newSupplier, extra = {}) {
      this.item.company_id = newSupplier.company_id
      this.item.company_name = newSupplier.company_name
      this.item.company.id = newSupplier.company_id
      this.item.company.name = newSupplier.company_name
      this.item.price_per_item = newSupplier.cost
      this.updatePrice(newSupplier.cost, {
        company_id: newSupplier.company_id,
        ...extra,
      })
    },
    async updatePrice(newPrice, extra = {}) {
      this.item.price_per_item = newPrice
      this.update({price: newPrice, ...extra})
    },
    async update(payload) {
      payload = {
        material_id: this.item.material_id,
        company_id: this.item.company_id === 0 ? null : this.item.company_id,
        price: this.item.price_per_item,
        ...payload
      }
      const materials = await this.estimate.updateMaterial(this.item.id, payload)
      this.$emit('updated', materials)
    }
  }
}
</script>
